<template>
    <div class="root-report-line" :data-id="id" :data-layout-type="reportNode?.layout?.type">
        <div class="root-report-line__header">
            <!-- <span class="number">{{ orderNumber }}</span> -->
            <span class="title">{{ reportNode.reportText || reportNode.layout.caption }}</span>
        </div>
        <div class="root-report-line__content">
            <template v-if="id == 'step_denticao'">
                <odontogramaCMP :id="id" v-if="execMode == gConsts.rt.execModes.WORK"></odontogramaCMP>

                <div class="children children--labels">
                    <denticaoReportLineCMP :execMode="execMode"></denticaoReportLineCMP>
                </div>
            </template>

            <section class="children" v-if="layerChildrenNodesOnReport.length > 0">
                <layerReportLineCMP v-for="child in layerChildrenNodesOnReport" 
                    :key="child.id" :node="child" :execMode="execMode" :canEdit="canEdit"
                    :activeNode="activeNode ? activeNode.layer == child.id ? activeNode : null : null" 
                    :id="child.id">
                </layerReportLineCMP>
            </section>

            <section class="children children--labels" v-if="labelChildrenNodesOnReport.length > 0">
                <labelReportLineCMP v-for="(child, index) in labelChildrenNodesOnReport"
                :key="child.id" :reportNode="labelChildrenReportNodes[index]" :execMode="execMode" :canEdit="canEdit"
                :active="activeNode ? activeNode.label == child.id : false" :id="child.id"></labelReportLineCMP>
            </section>
        </div>
    </div>
</template>

<script>
import { gConsts } from '@/globals/gConsts';
import { mapGetters } from 'vuex';
import layerReportLineCMP from './layerReportLine.vue';
import labelReportLineCMP from './labelReportLine.vue';
import odontogramaCMP from '@/components/panels/relatorioDinamico/nodes/odontograma.vue';
import denticaoReportLineCMP from './denticaoReportLine.vue';


export default {
    name: 'rootReportLineCMP',
    components: {
        layerReportLineCMP,
        labelReportLineCMP,
        denticaoReportLineCMP,
        odontogramaCMP,
    },
    props: {
        execMode: {
            type: String,
            default: gConsts.rt.execModes.WORK
        },
        reportNode: {
            type: Object,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        orderNumber: {
            type: Number,
            required: true
        },
        activeNode: {
            type: Object,
            default: null
        },
        canEdit: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            gConsts: gConsts,
            isActive: this.activeNode != null,
        }
    },

    methods: {
    },

    watch: {
        activeNode(newVal) {
            this.isActive = newVal != null;
        },
    },

    computed: {
        ...mapGetters([
            'GET_filteredNodes',
            'GET_reportNodes',
            'GET_reportNodes_validated',
        ]),

        activeReportNodes() {
            if (this.execMode == gConsts.rt.execModes.VIEW) {
                return this.GET_reportNodes_validated;
            }
            return this.GET_reportNodes;

        },

        layerChildren() { 
            return this.GET_filteredNodes.filter(node => 
                (node.layout.parent === this.reportNode.id) && node.layout.group == gConsts.node.layout.groups.FOLDER
            );
        },

        layerChildrenNodesOnReport() {
            return this.layerChildren.filter(child => this.activeReportNodes.find(reportNode => reportNode.id === child.id));
        },

        labelChildren() {
            if (this.id == 'step_livre') {
                return this.GET_filteredNodes.filter(node => (node.layout.parent === 'layer_anotsLivres'))
            }
            return [];
        },

        labelChildrenNodesOnReport() {
            return this.labelChildren.filter(child => this.activeReportNodes.find(reportNode => reportNode.id === child.id));
        },

        labelChildrenReportNodes() {
            return this.labelChildrenNodesOnReport.map(child => this.activeReportNodes.find(reportNode => reportNode.id === child.id));
        }
    },

    mounted() {
    }
}
</script>

<style scoped>
@import '../../styles/shared/reportLine/root_report_line.css';

#relatorio[data-exec-mode="work"] .root-report-line__content {
    gap: var(--spacing);
    padding: 0;
}

#relatorio[data-exec-mode="work"] .root-report-line__content .children {
    gap: var(--spacing-sm);
}

#relatorio[data-exec-mode="work"] .root-report-line__content .children--labels {
    padding-left: var(--spacing);
}

.root-report-line__header {
    cursor: default;
}

</style>